module.exports = __webpack_public_path__ + "static/media/astar_step_2.24ba25d0.png";